<script setup>
import { ref } from 'vue'

function getRandomWidth() {
  return `${Math.floor(Math.random() * (45 - 15 + 1)) + 15}%`
}

function getRandomBoolean() {
  return Math.random() < 0.5
}

function getRandomMessageCount(min = 4, max = 10) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const messageCount = getRandomMessageCount()

const messages = ref(
    Array.from({ length: messageCount }, () => ({
      formSelf: getRandomBoolean(),
    }))
)
</script>

<template>
  <div class="chat-content parent-height flex-1">
    <div
        class="msgs overflow-y-auto h-full space-y-3 flex flex-col-reverse custom-scrollbar"
        ref="messageContainer"
    >
      <div class="message-group relative space-y-3">
        <template v-for="(message, index) in messages" :key="index">
          <div class="block md:px-6 px-4">
            <div
                class="flex space-x-2 items-start group rtl:space-x-reverse"
                :class="{ 'w-full justify-end': !message.formSelf }"
            >
              <div :style="{ width: getRandomWidth() }">
                <div
                    class="animate-pulse text-contrent p-3 dark:text-slate-300 text-sm font-normal rounded-2xl flex-1 whitespace-pre-wrap break-all"
                    :class="
                    message.formSelf
                      ? 'bg-slate-300 dark:bg-slate-900 text-slate-800'
                      : 'bg-slate-100 dark:bg-slate-700 text-slate-600'
                  "
                >
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                </div>
                <div
                    class="animate-pulse w-[40px] h-[15px] my-1 rounded-md"
                    :class="
                    message.formSelf
                      ? 'bg-slate-300 dark:bg-slate-900'
                      : 'bg-slate-100 dark:bg-slate-700'
                  "
                ></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
